
<v-toolbar color="primary">
  <v-btn text :to="homeLink">
    <v-icon>home</v-icon>
  </v-btn>
  <v-spacer></v-spacer>
  <img class="logo" src="/api/logo">
  <v-spacer></v-spacer>
  <v-toolbar-items>
    <v-btn :class="{hidden: ! hasImages}" text to="/basket">
      <v-badge overlap bottom color="red">
        <template v-slot:badge color="white">{{ basketBadge }}</template>
        <v-icon>shopping_cart</v-icon>
      </v-badge>
    </v-btn>
  </v-toolbar-items>
</v-toolbar>
